import bannerQueries from '@apis/queries/bannerQueries';
import BannerCounter from '@components/BannerCounter';
import Image from '@components/Image';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useOnBannerClick from '@hooks/banner/useOnBannerClick';
import useAppCustom from '@hooks/useAppCustom';
import { pressActionEffect } from '@styles/mixin';
import { useQuery } from '@tanstack/react-query';
import { Fragment, useMemo, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

interface Props {
    type: 'MAIN_2' | 'MAIN_3';
}

function SubBanners({ type }: Props) {
    const banners = (useQuery(bannerQueries.list(type))).data?.banners;
    const [index, setIndex] = useState<number>(0);
    const onBannerClick = useOnBannerClick();
    const aspectRatio = type === 'MAIN_2' ? 4.21 : 2.2857;
    const { useSecondBanner, useThirdBanner } = useAppCustom().main;
    const isVisible = useMemo(() => {
        if (type === 'MAIN_2') {
            return useSecondBanner;
        }
        if (type === 'MAIN_3') {
            return useThirdBanner;
        }
        return false;
    }, [type, useSecondBanner, useThirdBanner]);
    if (banners && banners.length !== 0 && isVisible) {
        return (
            <Container data-type={type}>
                <Swiper loop
                    slidesPerView={1}
                    css={css`width: 100vw;`}
                    onSlideChange={(swiper) => {
                        setIndex(swiper.realIndex);
                    }}>
                    {banners.map((banner, i) => {
                        const { bannerLinkType } = banner;
                        return (
                            <SwiperSlide key={`${banner.contentId} ${i}`}>
                                <ImageWrapper>
                                    <StyledImage src={banner.imageUrl}
                                        onClick={() => onBannerClick(banner)}
                                        aspectRatio={aspectRatio}
                                        aria-disabled={bannerLinkType === 'NONE'}
                                        alt={banner.contentType} />
                                </ImageWrapper>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
                <BannerCounter totalCount={banners.length}
                    right={16}
                    bottom={0}
                    index={index}/>
            </Container>
        );
    }
    return (<Fragment/>);
}

const Container = styled.div`
    //margin: 0 0 var(--spacing-2);
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    &[data-type='MAIN_3'] {
        //margin-bottom: var(--spacing-12);
    }
`;

const ImageWrapper = styled.div`
    padding: 0 var(--spacing-4);
    overflow: hidden;
    width: 100vw;
`;

const StyledImage = styled(Image)<{
    aspectRatio: number;
}>`
    object-fit: cover;
    aspect-ratio: ${({ aspectRatio }) => aspectRatio};
    border-radius: var(--radius-sm);
    display: block;
    overflow: hidden;
    width: 100%;
    &[aria-disabled='false'] {
        ${pressActionEffect}
    }
`;

export default SubBanners;
